import { Quotation } from './types';

export const MOCK_QUOTATIONS: Quotation[] = [
  {
    id: 'quote-001',
    quoteNumber: 'TGI/2026/0012',
    date: '28/04/2026',
    validUntil: '28/05/2026',
    status: 'Approved',
    subject: 'Terrace Garden Design & Installation – Sector 62, Noida',
    preparedBy: 'Sanket Bhattacharya',
    clientName: 'Arvind Mehta',
    clientCompany: 'Mehta Residences',
    clientAddress: 'B-214, Sector 62',
    clientCity: 'Noida',
    clientState: 'Uttar Pradesh',
    clientPIN: '201301',
    clientPhone: '+91 9876543210',
    clientEmail: 'arvind.mehta@gmail.com',
    clientGSTIN: '09AAACM9999A1Z1',
    gstType: 'CGST+SGST',
    lineItems: [
      { id: 'li-001-1', srNo: 1, description: 'Consultation & site visit', hsn: '998391', qty: 1, unit: 'Job', rate: 2500, gstRate: 18, amount: 2500, gstAmount: 450, total: 2950 },
      { id: 'li-001-2', srNo: 2, description: 'Organic potting mix', hsn: '3101', qty: 12, unit: 'Bag', rate: 350, gstRate: 5, amount: 4200, gstAmount: 210, total: 4410 },
      { id: 'li-001-3', srNo: 3, description: 'FRP (Fibre-Reinforced Plastic) planters', hsn: '3926', qty: 10, unit: 'Nos', rate: 1800, gstRate: 18, amount: 18000, gstAmount: 3240, total: 21240 },
      { id: 'li-001-4', srNo: 4, description: 'Ornamental / flowering plants (potted)', hsn: '0602', qty: 20, unit: 'Plant', rate: 250, gstRate: 0, amount: 5000, gstAmount: 0, total: 5000 },
      { id: 'li-001-5', srNo: 5, description: 'Drip irrigation kit (terrace / rooftop)', hsn: '8424', qty: 1, unit: 'Set', rate: 8500, gstRate: 12, amount: 8500, gstAmount: 1020, total: 9520 },
      { id: 'li-001-6', srNo: 6, description: 'Terrace garden installation (per sqft)', hsn: '9954', qty: 100, unit: 'Sqft', rate: 85, gstRate: 18, amount: 8500, gstAmount: 1530, total: 10030 },
    ],
    subtotal: 46700,
    totalGST: 6450,
    grandTotal: 53150,
    terms: 'Payment: 50% advance on order confirmation; balance before delivery/installation. All prices are exclusive of GST. Quote valid for 30 days from the date above. Goods once delivered and accepted cannot be returned. Transportation charges are additional unless stated. Terrace waterproofing is the client\'s responsibility unless explicitly included in scope. Subject to New Delhi jurisdiction.',
    notes: 'All plants are nursery-grown and healthy at time of delivery. TGI is ISO 9001:2015 certified — quality guaranteed. A site visit is recommended before finalising quantities and scope. Warranty on irrigation hardware: 1 year from installation. AMC packages available separately. For queries, contact +91 96259 52842 or visit www.terracegardenindia.com.',
    createdAt: '2026-04-28T09:30:00.000Z',
    updatedAt: '2026-04-30T14:20:00.000Z',
  },
  {
    id: 'quote-002',
    quoteNumber: 'TGI/2026/0013',
    date: '29/04/2026',
    validUntil: '29/05/2026',
    status: 'Sent',
    subject: 'Vertical Garden Installation – Office Lobby, Bandra, Mumbai',
    preparedBy: 'Subhendu Bhattacharya',
    clientName: 'Priya Nair',
    clientCompany: 'InnoSpace Technologies Pvt. Ltd.',
    clientAddress: '4th Floor, Sunflower Complex, Bandra West',
    clientCity: 'Mumbai',
    clientState: 'Maharashtra',
    clientPIN: '400050',
    clientPhone: '+91 9988776655',
    clientEmail: 'priya.nair@innospace.in',
    clientGSTIN: '27AABCI1234A1Z5',
    gstType: 'IGST',
    lineItems: [
      { id: 'li-002-1', srNo: 1, description: 'Vertical garden pocket panels', hsn: '3926', qty: 40, unit: 'Sqft', rate: 450, gstRate: 18, amount: 18000, gstAmount: 3240, total: 21240 },
      { id: 'li-002-2', srNo: 2, description: 'Indoor shade-tolerant plants (Pothos, Fern, Money Plant)', hsn: '0602', qty: 60, unit: 'Plant', rate: 180, gstRate: 0, amount: 10800, gstAmount: 0, total: 10800 },
      { id: 'li-002-3', srNo: 3, description: 'Cocopeat (loose / compressed blocks)', hsn: '1404', qty: 8, unit: 'Bag', rate: 280, gstRate: 5, amount: 2240, gstAmount: 112, total: 2352 },
      { id: 'li-002-4', srNo: 4, description: 'Vertical garden installation (per sqft)', hsn: '9954', qty: 40, unit: 'Sqft', rate: 120, gstRate: 18, amount: 4800, gstAmount: 864, total: 5664 },
    ],
    subtotal: 35840,
    totalGST: 4216,
    grandTotal: 40056,
    terms: 'Payment: 50% advance on order confirmation; balance before delivery/installation. All prices are exclusive of GST. Quote valid for 30 days from the date above. Goods once delivered and accepted cannot be returned. Transportation charges are additional unless stated. Terrace waterproofing is the client\'s responsibility unless explicitly included in scope. Subject to New Delhi jurisdiction.',
    notes: 'All plants are nursery-grown and healthy at time of delivery. TGI is ISO 9001:2015 certified — quality guaranteed. A site visit is recommended before finalising quantities and scope. Warranty on irrigation hardware: 1 year from installation. AMC packages available separately. For queries, contact +91 96259 52842 or visit www.terracegardenindia.com.',
    createdAt: '2026-04-29T10:00:00.000Z',
    updatedAt: '2026-04-29T16:45:00.000Z',
  },
  {
    id: 'quote-003',
    quoteNumber: 'TGI/2026/0014',
    date: '30/04/2026',
    validUntil: '30/05/2026',
    status: 'Draft',
    subject: 'Kitchen Garden & Herb Setup – Vasant Kunj, New Delhi',
    preparedBy: 'Sanket Bhattacharya',
    clientName: 'Rekha Sharma',
    clientCompany: '',
    clientAddress: 'D-17, Vasant Kunj',
    clientCity: 'New Delhi',
    clientState: 'Delhi',
    clientPIN: '110070',
    clientPhone: '+91 9871234567',
    clientEmail: 'rekha.sharma@yahoo.com',
    clientGSTIN: '',
    gstType: 'CGST+SGST',
    lineItems: [
      { id: 'li-003-1', srNo: 1, description: 'HDPE grow bags (12", 18", 24")', hsn: '3923', qty: 20, unit: 'Nos', rate: 120, gstRate: 18, amount: 2400, gstAmount: 432, total: 2832 },
      { id: 'li-003-2', srNo: 2, description: 'Vegetable & herb saplings', hsn: '0602', qty: 30, unit: 'Plant', rate: 60, gstRate: 0, amount: 1800, gstAmount: 0, total: 1800 },
      { id: 'li-003-3', srNo: 3, description: 'Organic potting mix', hsn: '3101', qty: 8, unit: 'Bag', rate: 350, gstRate: 5, amount: 2800, gstAmount: 140, total: 2940 },
      { id: 'li-003-4', srNo: 4, description: 'Organic kit (fertiliser + pest control combo)', hsn: '3101', qty: 1, unit: 'Set', rate: 850, gstRate: 5, amount: 850, gstAmount: 42.5, total: 892.5 },
      { id: 'li-003-5', srNo: 5, description: 'Planting & soil preparation (per sqft)', hsn: '9986', qty: 40, unit: 'Sqft', rate: 45, gstRate: 18, amount: 1800, gstAmount: 324, total: 2124 },
    ],
    subtotal: 9650,
    totalGST: 938.5,
    grandTotal: 10588.5,
    terms: 'Payment: 50% advance on order confirmation; balance before delivery/installation. All prices are exclusive of GST. Quote valid for 30 days from the date above. Goods once delivered and accepted cannot be returned. Transportation charges are additional unless stated. Terrace waterproofing is the client\'s responsibility unless explicitly included in scope. Subject to New Delhi jurisdiction.',
    notes: 'All plants are nursery-grown and healthy at time of delivery. TGI is ISO 9001:2015 certified — quality guaranteed. A site visit is recommended before finalising quantities and scope. Warranty on irrigation hardware: 1 year from installation. AMC packages available separately. For queries, contact +91 96259 52842 or visit www.terracegardenindia.com.',
    createdAt: '2026-04-30T08:00:00.000Z',
    updatedAt: '2026-04-30T08:00:00.000Z',
  },
  {
    id: 'quote-004',
    quoteNumber: 'TGI/2026/0011',
    date: '25/04/2026',
    validUntil: '25/05/2026',
    status: 'Rejected',
    subject: 'Pergola & Outdoor Seating – Whitefield, Bengaluru',
    preparedBy: 'Subhendu Bhattacharya',
    clientName: 'Kiran Reddy',
    clientCompany: 'Reddy Constructions',
    clientAddress: '12, Whitefield Main Road',
    clientCity: 'Bengaluru',
    clientState: 'Karnataka',
    clientPIN: '560066',
    clientPhone: '+91 9845001234',
    clientEmail: 'kiran.reddy@reddycon.com',
    clientGSTIN: '29AABCR5678B1Z2',
    gstType: 'IGST',
    lineItems: [
      { id: 'li-004-1', srNo: 1, description: 'MS / GI pergola framework', hsn: '7308', qty: 1, unit: 'Set', rate: 45000, gstRate: 18, amount: 45000, gstAmount: 8100, total: 53100 },
      { id: 'li-004-2', srNo: 2, description: 'Pergola / structure installation', hsn: '9954', qty: 1, unit: 'Job', rate: 15000, gstRate: 18, amount: 15000, gstAmount: 2700, total: 17700 },
      { id: 'li-004-3', srNo: 3, description: 'Outdoor seating set (table + chairs)', hsn: '9401', qty: 1, unit: 'Set', rate: 22000, gstRate: 18, amount: 22000, gstAmount: 3960, total: 25960 },
      { id: 'li-004-4', srNo: 4, description: 'LED garden / pathway lights', hsn: '9405', qty: 6, unit: 'Nos', rate: 1200, gstRate: 18, amount: 7200, gstAmount: 1296, total: 8496 },
      { id: 'li-004-5', srNo: 5, description: 'Creepers & climbers', hsn: '0602', qty: 5, unit: 'Plant', rate: 350, gstRate: 0, amount: 1750, gstAmount: 0, total: 1750 },
    ],
    subtotal: 90950,
    totalGST: 16056,
    grandTotal: 107006,
    terms: 'Payment: 50% advance on order confirmation; balance before delivery/installation. All prices are exclusive of GST. Quote valid for 30 days from the date above. Goods once delivered and accepted cannot be returned. Transportation charges are additional unless stated. Terrace waterproofing is the client\'s responsibility unless explicitly included in scope. Subject to New Delhi jurisdiction.',
    notes: 'All plants are nursery-grown and healthy at time of delivery. TGI is ISO 9001:2015 certified — quality guaranteed. A site visit is recommended before finalising quantities and scope. Warranty on irrigation hardware: 1 year from installation. AMC packages available separately. For queries, contact +91 96259 52842 or visit www.terracegardenindia.com.',
    createdAt: '2026-04-25T11:00:00.000Z',
    updatedAt: '2026-04-27T09:30:00.000Z',
  },
  {
    id: 'quote-005',
    quoteNumber: 'TGI/2026/0015',
    date: '01/05/2026',
    validUntil: '31/05/2026',
    status: 'Draft',
    subject: 'AMC – Annual Maintenance Contract – DLF Phase 2, Gurgaon',
    preparedBy: 'Sanket Bhattacharya',
    clientName: 'Neha Kapoor',
    clientCompany: 'Kapoor Housing Society',
    clientAddress: 'F-Block, DLF Phase 2',
    clientCity: 'Gurgaon',
    clientState: 'Haryana',
    clientPIN: '122002',
    clientPhone: '+91 9810098100',
    clientEmail: 'neha.kapoor@dlf.in',
    clientGSTIN: '06AABCK7890C1Z3',
    gstType: 'CGST+SGST',
    lineItems: [
      { id: 'li-005-1', srNo: 1, description: 'Monthly gardening visit', hsn: '9986', qty: 12, unit: 'Nos', rate: 3500, gstRate: 18, amount: 42000, gstAmount: 7560, total: 49560 },
      { id: 'li-005-2', srNo: 2, description: 'Quarterly fertilisation & pest control', hsn: '9986', qty: 4, unit: 'Nos', rate: 2500, gstRate: 18, amount: 10000, gstAmount: 1800, total: 11800 },
      { id: 'li-005-3', srNo: 3, description: 'Seasonal replanting service', hsn: '9986', qty: 2, unit: 'Job', rate: 5000, gstRate: 18, amount: 10000, gstAmount: 1800, total: 11800 },
      { id: 'li-005-4', srNo: 4, description: 'Emergency garden call-out', hsn: '9986', qty: 2, unit: 'Nos', rate: 1500, gstRate: 18, amount: 3000, gstAmount: 540, total: 3540 },
    ],
    subtotal: 65000,
    totalGST: 11700,
    grandTotal: 76700,
    terms: 'Payment: 50% advance on order confirmation; balance before delivery/installation. All prices are exclusive of GST. Quote valid for 30 days from the date above. Goods once delivered and accepted cannot be returned. Transportation charges are additional unless stated. Terrace waterproofing is the client\'s responsibility unless explicitly included in scope. Subject to New Delhi jurisdiction.',
    notes: 'All plants are nursery-grown and healthy at time of delivery. TGI is ISO 9001:2015 certified — quality guaranteed. A site visit is recommended before finalising quantities and scope. Warranty on irrigation hardware: 1 year from installation. AMC packages available separately. For queries, contact +91 96259 52842 or visit www.terracegardenindia.com.',
    createdAt: '2026-05-01T07:00:00.000Z',
    updatedAt: '2026-05-01T07:00:00.000Z',
  },
  {
    id: 'quote-006',
    quoteNumber: 'TGI/2026/0010',
    date: '22/04/2026',
    validUntil: '22/05/2026',
    status: 'Approved',
    subject: 'Water Feature & Pond – Boat Club Road, Pune',
    preparedBy: 'Subhendu Bhattacharya',
    clientName: 'Suresh Joshi',
    clientCompany: '',
    clientAddress: '7, Boat Club Road',
    clientCity: 'Pune',
    clientState: 'Maharashtra',
    clientPIN: '411001',
    clientPhone: '+91 9823456789',
    clientEmail: 'suresh.joshi@outlook.com',
    clientGSTIN: '',
    gstType: 'IGST',
    lineItems: [
      { id: 'li-006-1', srNo: 1, description: 'GRC / FRP water fountain', hsn: '6810', qty: 1, unit: 'Nos', rate: 35000, gstRate: 12, amount: 35000, gstAmount: 4200, total: 39200 },
      { id: 'li-006-2', srNo: 2, description: 'Water feature pump (submersible)', hsn: '8413', qty: 1, unit: 'Nos', rate: 4500, gstRate: 18, amount: 4500, gstAmount: 810, total: 5310 },
      { id: 'li-006-3', srNo: 3, description: 'Aquatic / pond plants', hsn: '0602', qty: 8, unit: 'Plant', rate: 300, gstRate: 0, amount: 2400, gstAmount: 0, total: 2400 },
      { id: 'li-006-4', srNo: 4, description: 'Underwater LED pond lights', hsn: '9405', qty: 3, unit: 'Nos', rate: 1800, gstRate: 18, amount: 5400, gstAmount: 972, total: 6372 },
      { id: 'li-006-5', srNo: 5, description: 'Water feature installation', hsn: '9954', qty: 1, unit: 'Job', rate: 12000, gstRate: 18, amount: 12000, gstAmount: 2160, total: 14160 },
    ],
    subtotal: 59300,
    totalGST: 8142,
    grandTotal: 67442,
    terms: 'Payment: 50% advance on order confirmation; balance before delivery/installation. All prices are exclusive of GST. Quote valid for 30 days from the date above. Goods once delivered and accepted cannot be returned. Transportation charges are additional unless stated. Terrace waterproofing is the client\'s responsibility unless explicitly included in scope. Subject to New Delhi jurisdiction.',
    notes: 'All plants are nursery-grown and healthy at time of delivery. TGI is ISO 9001:2015 certified — quality guaranteed. A site visit is recommended before finalising quantities and scope. Warranty on irrigation hardware: 1 year from installation. AMC packages available separately. For queries, contact +91 96259 52842 or visit www.terracegardenindia.com.',
    createdAt: '2026-04-22T13:00:00.000Z',
    updatedAt: '2026-04-24T10:00:00.000Z',
  },
  {
    id: 'quote-007',
    quoteNumber: 'TGI/2026/0009',
    date: '18/04/2026',
    validUntil: '18/05/2026',
    status: 'Sent',
    subject: 'Office Interior Landscaping – Hitech City, Hyderabad',
    preparedBy: 'Sanket Bhattacharya',
    clientName: 'Venkat Rao',
    clientCompany: 'TechPark Solutions Ltd.',
    clientAddress: 'Plot 42, Hitech City',
    clientCity: 'Hyderabad',
    clientState: 'Telangana',
    clientPIN: '500081',
    clientPhone: '+91 9912345678',
    clientEmail: 'venkat.rao@techpark.in',
    clientGSTIN: '36AABCT3456D1Z7',
    gstType: 'IGST',
    lineItems: [
      { id: 'li-007-1', srNo: 1, description: 'Indoor shade-tolerant plants (Pothos, Fern, Money Plant)', hsn: '0602', qty: 25, unit: 'Plant', rate: 220, gstRate: 0, amount: 5500, gstAmount: 0, total: 5500 },
      { id: 'li-007-2', srNo: 2, description: 'FRP (Fibre-Reinforced Plastic) planters', hsn: '3926', qty: 20, unit: 'Nos', rate: 1600, gstRate: 18, amount: 32000, gstAmount: 5760, total: 37760 },
      { id: 'li-007-3', srNo: 3, description: 'Organic potting mix', hsn: '3101', qty: 6, unit: 'Bag', rate: 350, gstRate: 5, amount: 2100, gstAmount: 105, total: 2205 },
      { id: 'li-007-4', srNo: 4, description: 'Office plantation / interior landscaping', hsn: '9986', qty: 1, unit: 'Job', rate: 18000, gstRate: 18, amount: 18000, gstAmount: 3240, total: 21240 },
      { id: 'li-007-5', srNo: 5, description: 'Monthly gardening visit', hsn: '9986', qty: 12, unit: 'Nos', rate: 3000, gstRate: 18, amount: 36000, gstAmount: 6480, total: 42480 },
    ],
    subtotal: 93600,
    totalGST: 15585,
    grandTotal: 109185,
    terms: 'Payment: 50% advance on order confirmation; balance before delivery/installation. All prices are exclusive of GST. Quote valid for 30 days from the date above. Goods once delivered and accepted cannot be returned. Transportation charges are additional unless stated. Terrace waterproofing is the client\'s responsibility unless explicitly included in scope. Subject to New Delhi jurisdiction.',
    notes: 'All plants are nursery-grown and healthy at time of delivery. TGI is ISO 9001:2015 certified — quality guaranteed. A site visit is recommended before finalising quantities and scope. Warranty on irrigation hardware: 1 year from installation. AMC packages available separately. For queries, contact +91 96259 52842 or visit www.terracegardenindia.com.',
    createdAt: '2026-04-18T09:00:00.000Z',
    updatedAt: '2026-04-19T14:00:00.000Z',
  },
  {
    id: 'quote-008',
    quoteNumber: 'TGI/2026/0016',
    date: '01/05/2026',
    validUntil: '31/05/2026',
    status: 'Draft',
    subject: 'Rooftop Garden – Adyar, Chennai',
    preparedBy: 'Sanket Bhattacharya',
    clientName: 'Meenakshi Sundaram',
    clientCompany: '',
    clientAddress: '23, 4th Cross, Adyar',
    clientCity: 'Chennai',
    clientState: 'Tamil Nadu',
    clientPIN: '600020',
    clientPhone: '+91 9944556677',
    clientEmail: 'meenakshi.s@gmail.com',
    clientGSTIN: '',
    gstType: 'IGST',
    lineItems: [
      { id: 'li-008-1', srNo: 1, description: 'Consultation & site visit', hsn: '998391', qty: 1, unit: 'Job', rate: 2500, gstRate: 18, amount: 2500, gstAmount: 450, total: 2950 },
      { id: 'li-008-2', srNo: 2, description: 'HDPE waterproof terrace membrane', hsn: '3921', qty: 150, unit: 'Sqm', rate: 180, gstRate: 18, amount: 27000, gstAmount: 4860, total: 31860 },
      { id: 'li-008-3', srNo: 3, description: 'Drainage mat / geotextile layer', hsn: '5911', qty: 150, unit: 'Sqm', rate: 95, gstRate: 12, amount: 14250, gstAmount: 1710, total: 15960 },
      { id: 'li-008-4', srNo: 4, description: 'Organic potting mix', hsn: '3101', qty: 20, unit: 'Bag', rate: 350, gstRate: 5, amount: 7000, gstAmount: 350, total: 7350 },
      { id: 'li-008-5', srNo: 5, description: 'Ornamental / flowering plants (potted)', hsn: '0602', qty: 30, unit: 'Plant', rate: 280, gstRate: 0, amount: 8400, gstAmount: 0, total: 8400 },
      { id: 'li-008-6', srNo: 6, description: 'Terrace garden installation (per sqft)', hsn: '9954', qty: 150, unit: 'Sqft', rate: 85, gstRate: 18, amount: 12750, gstAmount: 2295, total: 15045 },
    ],
    subtotal: 71900,
    totalGST: 9665,
    grandTotal: 81565,
    terms: 'Payment: 50% advance on order confirmation; balance before delivery/installation. All prices are exclusive of GST. Quote valid for 30 days from the date above. Goods once delivered and accepted cannot be returned. Transportation charges are additional unless stated. Terrace waterproofing is the client\'s responsibility unless explicitly included in scope. Subject to New Delhi jurisdiction.',
    notes: 'All plants are nursery-grown and healthy at time of delivery. TGI is ISO 9001:2015 certified — quality guaranteed. A site visit is recommended before finalising quantities and scope. Warranty on irrigation hardware: 1 year from installation. AMC packages available separately. For queries, contact +91 96259 52842 or visit www.terracegardenindia.com.',
    createdAt: '2026-05-01T05:00:00.000Z',
    updatedAt: '2026-05-01T05:00:00.000Z',
  },
];